"use client";

import { useState } from "react";
import { NewsYearMonth } from "@/@types";
import Link from "next/link";
import { ROUTES } from "@/config/routes";
import IconSprite from "../common/IconSprite";

type Props = {
  yearMonths: NewsYearMonth[];
};

export default function NewsYearMonthCard({ yearMonths }: Props) {
  const [openMonths, setOpenMonths] = useState<{ [key: string]: boolean }>({});

  const toggleMonth = (key: string) => {
    setOpenMonths((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const capitalizeFirstLetter = (str: string): string =>
    str.charAt(0).toUpperCase() + str.slice(1);

  return (
    <div>
      {yearMonths.map((yearMonth) => (
        <div key={yearMonth.year}>
          <div className="bg-white">
            {yearMonth.months.map((month) => {
              const isOpen = openMonths[`${yearMonth.year}-${month.month}`];

              return (
                <div key={month.month}>
                  <button
                    onClick={() => toggleMonth(`${yearMonth.year}-${month.month}`)}
                    className="w-full flex items-center justify-between border-grey border-b-2 p-2 text-dark01 hover:bg-light01 focus:outline-none"
                  >
                    <span>{`${capitalizeFirstLetter(month.month)} ${yearMonth.year}`}</span>
                    <IconSprite id="ic_arrow_down" className={`${isOpen ? 'rotate-180' : ''} w-3 h-3`} />
                  </button>

                  {isOpen && (
                    <div className="bg-light00">
                      {month.news.map((news) => (
                        <Link
                          key={news.id}
                          href={ROUTES.news.details(news.categorySlug, news.slug)}
                          className="block py-2 text-sm text-dark01 hover:bg-light01 px-2 border-b border-light01"
                        >
                          {`${news.title}`}
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
